import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormControl } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Observable, Subscription } from 'rxjs';
import { APIService } from '../../fleet-management/backend-service/backend-service';
import { GlobalVariablesService } from '../../global.service';
import { SettingService } from '../setting-service';
import { SettingData } from '../../models/settings.model';
import { NotificationService } from '../../shared/services/notification.service';
import { ConfirmationDialogService } from '../../shared/services/confirmation-dialog.service';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-truck-settings',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatSelectModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './truck-settings.component.html',
  styleUrl: './truck-settings.component.scss'
})
export class TruckSettingsComponent implements OnDestroy {
  searchControl = new FormControl('');
  typeOfTrucks: SettingData[] = [];
  truckModels: SettingData[] = [];
  truckLoandingCapacity: SettingData[] = [];
  boxSizes: SettingData[] = [];
  boxLoadingType: SettingData[] = [];
  vehicleMaintenances: SettingData[] = [];
  incidentReport: SettingData[] = [];
  routeExpertise: SettingData[] = [];
  insuranceTypes: SettingData[] = [];
  securityDepositAmount: SettingData[] = [];
  filteredOptions!: Observable<string[]>;
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  constructor(private apiService: APIService, private globalVariable: GlobalVariablesService, private settingService: SettingService,
    private notification: NotificationService, private confirmationDialog: ConfirmationDialogService,
    public loadingService: LoadingService) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    // this.setUserRoles();
    this.getSettingsFromAPI();
  }

  getSettingsFromAPI(): void {
    this.settingService.getSettings().subscribe({
      next: (response) => {
        console.log('Settings loaded successfully:', response);
        this.setTypeOfTruck();
        this.setTruckModel();
        this.setTruckLoadCapacity();
        this.setBoxSize();
        this.setBoxLoadingType();
        this.setVehicleMaintenances();
        this.setIncidentReport();
        this.setRouteExpertise();
        this.setInsuranceTypes();
        this.setSecurityDepositAmount();
      },
      error: (error) => {
        console.error('Error loading settings:', error);
      }
    });
  }
  setTypeOfTruck() {
    for (const role of this.globalVariable.SETTING_TRUCK_TYPES || []) {
      if (!this.typeOfTrucks.some(r => r["id"] === role.id)) {
        this.typeOfTrucks.push(role);
      }
    }
  }
  setTruckModel() {
    for (const role of this.globalVariable.SETTING_TRUCK_MODEL_NUMBERS || []) {
      if (!this.truckModels.some(r => r["id"] === role.id)) {
        this.truckModels.push(role);
      }
    }
  }
  setTruckLoadCapacity() {
    for (const role of this.globalVariable.SETTING_TRUCK_LOADING_CAPACITY || []) {
      if (!this.truckLoandingCapacity.some(r => r["id"] === role.id)) {
        this.truckLoandingCapacity.push(role);
      }
    }
  }
  setBoxSize() {
    for (const role of this.globalVariable.SETTING_BOX_SIZE || []) {
      if (!this.boxSizes.some(r => r["id"] === role.id)) {
        this.boxSizes.push(role);
      }
    }
  }
  setBoxLoadingType() {
    for (const role of this.globalVariable.SETTING_BOX_LOADING_TYPES || []) {
      if (!this.boxLoadingType.some(r => r["id"] === role.id)) {
        this.boxLoadingType.push(role);
      }
    }
  }
  setVehicleMaintenances() {
    for (const role of this.globalVariable.SETTING_VEHICLE_MAINTENANCE || []) {
      if (!this.vehicleMaintenances.some(r => r["id"] === role.id)) {
        this.vehicleMaintenances.push(role);
      }
    }
  }
  setIncidentReport() {
    for (const role of this.globalVariable.SETTING_INCIDENT_REPORT || []) {
      if (!this.incidentReport.some(r => r["id"] === role.id)) {
        this.incidentReport.push(role);
      }
    }
  }
  setRouteExpertise() {
    for (const role of this.globalVariable.SETTING_ROUTE_EXPERTISE || []) {
      if (!this.routeExpertise.some(r => r["id"] === role.id)) {
        this.routeExpertise.push(role);
      }
    }
  }
  setInsuranceTypes() {
    for (const role of this.globalVariable.SETTING_INSURANCE_TYPES || []) {
      if (!this.insuranceTypes.some(r => r["id"] === role.id)) {
        this.insuranceTypes.push(role);
      }
    }
  }
  setSecurityDepositAmount() {
    for (const role of this.globalVariable.SETTING_SECURITY_DEPOSIT_AMOUNT || []) {
      if (!this.securityDepositAmount.some(r => r["id"] === role.id)) {
        this.securityDepositAmount.push(role);
      }
    }
  }


  addNewSetting(roleName: string, endpoint: string): void {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    let jsonData = {
      "name": roleName,
    }
    console.log("Setting data: ", jsonData)
    this.apiService.post(endpoint, jsonData, loginData.token)
      .subscribe({
        next: (response) => {
          console.log('HTTP Status:', response.status); // 👈 Get status here
          console.log('Response Body:', response.body);
          if (response.status === 200 || response.status === 201) {
            this.getSettingsFromAPI();
            this.notification.success('Add New Setting successfully');

          }
          else {
            this.notification.error('Add New Setting failed. Please try again.');
          }
        },
        error: (err) => {
          console.error('Error Status:', err.status);    // 👈 Also available on error
          console.error('Error Message:', err.error);
        }
      });
  }
  deleteSetting(settingId: String, endpoint: string): void {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.delete(endpoint + settingId, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log(endpoint + ',\n' + 'Delete_Setting_Response:', response);
        if (response.status === 200) {
          this.getSettingsFromAPI();
        }
        this.notification.success(response.message || 'Operation completed successfully');

      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }

  addTypeOfTrucks(): void {
    const value = this.searchControl.value?.trim();
    if (value && !this.typeOfTrucks.some(role => role.name === value)) {
      this.addNewSetting(value, '/api/predefined-data/TRUCK_TYPES');
    }
    this.searchControl.setValue('');
  }
  removeTypeOfTrucks(item: SettingData) {
    this.confirmationDialog.confirmDelete(item.name).subscribe(confirmed => {
      if (confirmed) {
        this.typeOfTrucks = this.typeOfTrucks.filter(i => i.id !== item.id);
        this.deleteSetting(item.id, '/api/predefined-data/TRUCK_TYPES/');
      }
    });
  }
  

  addTruckModels(): void {
    const value = this.searchControl.value?.trim();
    if (value && !this.truckModels.some(role => role.name === value)) {
      this.addNewSetting(value, '/api/predefined-data/TRUCK_MODEL_NUMBERS');
    }
    this.searchControl.setValue('');
  }
  removeTruckModels(item: SettingData) {
    this.confirmationDialog.confirmDelete(item.name).subscribe(confirmed => {
      if (confirmed) {
        this.truckModels = this.truckModels.filter(i => i.id !== item.id);
        this.deleteSetting(item.id, '/api/predefined-data/TRUCK_MODEL_NUMBERS/');
      }
    });
  }

  addTruckLoadingCapacity(): void {
    const value = this.searchControl.value?.trim();
    if (value && !this.truckLoandingCapacity.some(role => role.name === value)) {
      this.addNewSetting(value, '/api/predefined-data/TRUCK_LOADING_CAPACITY');
    }
    this.searchControl.setValue('');
  }
  removeTruckLoadingCapacity(item: SettingData) {
    this.confirmationDialog.confirmDelete(item.name).subscribe(confirmed => {
      if (confirmed) {
        this.truckLoandingCapacity = this.truckLoandingCapacity.filter(i => i.id !== item.id);
        this.deleteSetting(item.id, '/api/predefined-data/TRUCK_LOADING_CAPACITY/');
      }
    });
  }

  addBoxSizes(): void {
    const value = this.searchControl.value?.trim();
    if (value && !this.boxSizes.some(role => role.name === value)) {
      this.addNewSetting(value, '/api/predefined-data/BOX_SIZE');
    }
    this.searchControl.setValue('');
  }
  removeBoxSize(item: SettingData) {
    this.confirmationDialog.confirmDelete(item.name).subscribe(confirmed => {
      if (confirmed) {
        this.boxSizes = this.boxSizes.filter(i => i.id !== item.id);
        this.deleteSetting(item.id, '/api/predefined-data/BOX_SIZE/');
      }
    });
  }

  addBoxLoadingType(): void {
    const value = this.searchControl.value?.trim();
    if (value && !this.boxLoadingType.some(role => role.name === value)) {
      this.addNewSetting(value, '/api/predefined-data/BOX_LOADING_TYPES');
    }
    this.searchControl.setValue('');
  }
  removeBoxLoadingType(item: SettingData) {
    this.confirmationDialog.confirmDelete(item.name).subscribe(confirmed => {
      if (confirmed) {
        this.boxLoadingType = this.boxLoadingType.filter(i => i.id !== item.id);
        this.deleteSetting(item.id, '/api/predefined-data/BOX_LOADING_TYPES/');
      }
    });
  }

  addVehicleMaintenance(): void {
    const value = this.searchControl.value?.trim();
    if (value && !this.vehicleMaintenances.some(role => role.name === value)) {
      this.addNewSetting(value, '/api/predefined-data/VEHICLE_MAINTENANCE');
    }
    this.searchControl.setValue('');
  }
  removeVehicleMaintenance(item: SettingData) {
    this.confirmationDialog.confirmDelete(item.name).subscribe(confirmed => {
      if (confirmed) {
        this.vehicleMaintenances = this.vehicleMaintenances.filter(i => i.id !== item.id);
        this.deleteSetting(item.id, '/api/predefined-data/VEHICLE_MAINTENANCE/');
      }
    });
  }

  addIncidentReport(): void {
    const value = this.searchControl.value?.trim();
    if (value && !this.incidentReport.some(role => role.name === value)) {
      this.addNewSetting(value, '/api/predefined-data/INCIDENT_REPORT');
    }
    this.searchControl.setValue('');
  }
  removeIncidentReport(item: SettingData) {
    this.confirmationDialog.confirmDelete(item.name).subscribe(confirmed => {
      if (confirmed) {
        this.incidentReport = this.incidentReport.filter(i => i.id !== item.id);
        this.deleteSetting(item.id, '/api/predefined-data/INCIDENT_REPORT/');
      }
    });
  }

  addRouteExpertise(): void {
    const value = this.searchControl.value?.trim();
    if (value && !this.routeExpertise.some(role => role.name === value)) {
      this.addNewSetting(value, '/api/predefined-data/ROUTE_EXPERTISE');
    }
    this.searchControl.setValue('');
  }
  removeRouteExpertise(item: SettingData) {
    this.confirmationDialog.confirmDelete(item.name).subscribe(confirmed => {
      if (confirmed) {
        this.routeExpertise = this.routeExpertise.filter(i => i.id !== item.id);
        this.deleteSetting(item.id, '/api/predefined-data/ROUTE_EXPERTISE/');
      }
    });
  }

  addInsuranceType(): void {
    const value = this.searchControl.value?.trim();
    if (value && !this.insuranceTypes.some(role => role.name === value)) {
      this.addNewSetting(value, '/api/predefined-data/INSURANCE_TYPES');
    }
    this.searchControl.setValue('');
  }
  removeInsuranceType(item: SettingData) {
    this.confirmationDialog.confirmDelete(item.name).subscribe(confirmed => {
      if (confirmed) {
        this.insuranceTypes = this.insuranceTypes.filter(i => i.id !== item.id);
        this.deleteSetting(item.id, '/api/predefined-data/INSURANCE_TYPES/');
      }
    });
  }

  addSecurityDepositAmount(): void {
    const value = this.searchControl.value?.trim();
    if (value && !this.securityDepositAmount.some(role => role.name === value)) {
      this.addNewSetting(value, '/api/predefined-data/SECURITY_DEPOSIT_AMOUNT');
    }
    this.searchControl.setValue('');
  }
  removeSecurityDepositAmount(item: SettingData) {
    this.confirmationDialog.confirmDelete(item.name).subscribe(confirmed => {
      if (confirmed) {
        this.securityDepositAmount = this.securityDepositAmount.filter(i => i.id !== item.id);
        this.deleteSetting(item.id, '/api/predefined-data/SECURITY_DEPOSIT_AMOUNT/');
      }
    });
  }
}
